import { render, staticRenderFns } from "./cancelInvoice.vue?vue&type=template&id=67b78af8&scoped=true"
import script from "./cancelInvoice.vue?vue&type=script&lang=js"
export * from "./cancelInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b78af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b78af8')) {
      api.createRecord('67b78af8', component.options)
    } else {
      api.reload('67b78af8', component.options)
    }
    module.hot.accept("./cancelInvoice.vue?vue&type=template&id=67b78af8&scoped=true", function () {
      api.rerender('67b78af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/etc/cmp/cancelInvoice.vue"
export default component.exports